import { Helpers } from '../../helpers';
import { IForecastParemeterProductType } from '../../interfaces/iforecast-paremeter-product-type';
import { ForecastParameterDetail } from '../forecast-parameter-detail';
import { TypeCurveParameter } from '../type-curve-parameter';

export class ForecastParemeterProductTypeBase {
  ForecastParameterProductTypeId: number;
  Name: string;
  UpdatedBy: string;
  Created: Date;
  Updated: Date;
  CreatedBy: string;

  ForecastParameterDetails_ForecastParamterProductType?: Array<ForecastParameterDetail> | null;
  TypeCurveParameters_ForecastProductType?: Array<TypeCurveParameter> | null;

  constructor(item?: IForecastParemeterProductType) {
    if (item) {

      this.ForecastParameterProductTypeId = item.ForecastParameterProductTypeId;
      this.Name = item.Name;
      this.UpdatedBy = item.UpdatedBy;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.CreatedBy = item.CreatedBy;

      this.ForecastParameterDetails_ForecastParamterProductType = Helpers.createClassArray(ForecastParameterDetail, item.ForecastParameterDetails_ForecastParamterProductType);
      this.TypeCurveParameters_ForecastProductType = Helpers.createClassArray(TypeCurveParameter, item.TypeCurveParameters_ForecastProductType);
    }
  }
}